import { http } from '../utils/http'

const searchAction = (params,page,size) => {
  params.page = page
  params.size = size
  const url = `/config/mappingTopic/page`
  return http.post(url, params)
};
const deleteAction = (id) => {
  const url = `/config/mappingTopic/delete/${id}`
  return http.post(url)
};
const saveAction = (params) => {
  const url = `/config/mappingTopic/save`
  return http.post(url, params)
};
const detailsAction = (id) => {
  const url = `/config/mappingTopic/get/${id}`
  return http.post(url)
};
const activeAction = (id,active) => {
  const url = `/config/mappingTopic/active/${id}/${active}`
  return http.post(url)
};
const getInboundNameAction = (id) => {
  const url = `/config/apiConfigInfo/getInboundApiConfigList/${id}`
  return http.post(url)
};
const getInboundNameWithoutHttpAction = (id) => {
  const url = `/config/apiConfigInfo/job/getInboundApiConfigList/${id}`
  return http.post(url)
};
const getInboundNamesAction = (params) => {
  const url = `/config/apiConfigInfo/getInboundApiConfigListByIds`
  return http.post(url,params)
};
const getOutboundNameAction = (id) => {
  const url = `/config/apiConfigInfo/getOutboundApiConfigList/${id}`
  return http.post(url)
};
const getInboundAction = (id) => {
  const url = `/config/apiConfigInfo/get/${id}`
  return http.post(url)
};
const getOutboundAction = (id) => {
  const url = `/config/apiConfigInfo/get/${id}`
  return http.post(url)
};
const getCustAction = () => {
  const url = `/config/customer/list`
  return http.post(url, {})
};

const getVersion = (id,versionType) => {
  const url = `/config/apiManagement/list/${id}/${versionType}`
  return http.post(url)
};
const saveVersion = (id,versionType,param) => {
  param.versionDataType = versionType
  const url = `/config/apiManagement/save/${id}`
  return http.post(url,param)
};
const saveRollbackAction = (id,versionId,versionType,param) => {
  param.versionDataType = versionType
  const url =`/config/apiManagement/rollback/${id}/${versionId}`
  return http.post(url,param)
};
const getFormulaInfoList = () => {
  const url = `/config/formulaType/listTypeAndFormulaInfo`
  return http.post(url)
};
const getGroovyAction = (client) => {
  const url = `/config/groovyScript/clientList/${client}`
  return http.post(url)
};
const getGroovyDetailAction = (id) => {
  const url = `/config/groovyScript/get/${id}`
  return http.post(url, {})
};
export default {
  getCustAction,
  searchAction,
  saveAction,
  detailsAction,
  activeAction,
  deleteAction,
  getInboundNameAction,
  getInboundNameWithoutHttpAction,
  getInboundNamesAction,
  getOutboundNameAction,
  getInboundAction,
  getOutboundAction,
  getVersion,
  saveVersion,
  saveRollbackAction,
  getFormulaInfoList,
  getGroovyAction,
  getGroovyDetailAction
}
